import { Field, Item } from '@sitecore-jss/sitecore-jss-nextjs';

export enum DisplayTypeEnum {
  hide = 'Hide',
  show = 'Show',
}

export type QueryParamsFields = {
  queryParamKey?: Field<string>;
  queryParamValue?: Field<string>;
  queryParamAction?: Item;
};
